import api from "./api"
import { getStoredShipper, getPlanType } from "../constants/utils"
import { labels } from "../constants/labels"

const PLAN_ROOT = "plan"
const EQUIPMENT_TYPE_ROOT =
    "api/v1/config/config-type/APP/config-keys?configKeyList=EQUIPMENT_TYPE&appName=RVP"

const planApi = {
    getAllData() {
        return api.get(`${EQUIPMENT_TYPE_ROOT}`, "PLATFORM_SERVICE")
    },
    getAllPlans() {
        const { STORED_SHIPPER_NAME_ENCODED, STORED_RAILROAD_NAME_ENCODED } =
            getStoredShipper()

        return api.get(
            `${PLAN_ROOT}/${STORED_RAILROAD_NAME_ENCODED}/${STORED_SHIPPER_NAME_ENCODED}`,
            "ROOT"
        )
    },
    getPlan({ planName }) {
        const { STORED_SHIPPER_NAME_ENCODED, STORED_RAILROAD_NAME_ENCODED } =
            getStoredShipper()

        return api.get(
            `${PLAN_ROOT}/${STORED_RAILROAD_NAME_ENCODED}/${STORED_SHIPPER_NAME_ENCODED}/${planName}`,
            "ROOT"
        )
    },
    updatePlan({
        name,
        aartypes,
        description,
        status,
        planType,
        commodityDetails,
    }) {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        return api.put(
            `${PLAN_ROOT}/`,
            {
                planName: name,
                planDescription: description,
                leStatus: status,
                roadId: STORED_RAILROAD_NAME,
                shipperId: STORED_SHIPPER_NAME,
                planType: getPlanType(planType),
                carTypes:
                    planType === labels.planLbl.equipmentType ? aartypes : null,
                railCarPlanCommodity:
                    planType === labels.planLbl.commodity
                        ? commodityDetails
                        : null,
            },
            "ROOT"
        )
    },
    getCarSpecifications(car) {
        return api.get(`${PLAN_ROOT}/type/${car}`)
    },
    getAllPositionData({ car, status }) {
        return api.get(`${PLAN_ROOT}/type/${car}/positions/${status}`)
    },
    createNewPlan({
        name,
        description,
        status,
        aartypes,
        baseUrl,
        planType,
        commodityDetails,
    }) {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()
        return api.post(
            `${PLAN_ROOT}/`,
            {
                planName: name,
                planDescription: description,
                roadId: STORED_RAILROAD_NAME,
                shipperId: STORED_SHIPPER_NAME,
                leStatus: status,
                planType: getPlanType(planType),
                carTypes:
                    planType === labels.planLbl.equipmentType ? aartypes : null,
                railCarPlanCommodity:
                    planType === labels.planLbl.commodity
                        ? commodityDetails
                        : null,
            },
            baseUrl
        )
    },
    putPlanDefault(planName, planCategory) {
        const { STORED_SHIPPER_NAME_ENCODED, STORED_RAILROAD_NAME_ENCODED } =
            getStoredShipper()

        return api.put(
            `${PLAN_ROOT}/updateDefault/${STORED_RAILROAD_NAME_ENCODED}/${STORED_SHIPPER_NAME_ENCODED}/${planName}/${planCategory}`,
            "ROOT"
        )
    },
    deleteExistingPlan(planName) {
        const { STORED_SHIPPER_NAME_ENCODED, STORED_RAILROAD_NAME_ENCODED } =
            getStoredShipper()

        return api.delete(
            `${PLAN_ROOT}/${STORED_RAILROAD_NAME_ENCODED}/${STORED_SHIPPER_NAME_ENCODED}/${planName}`,
            "ROOT"
        )
    },
}

export default planApi
